export default "<app-spinner></app-spinner>\r\n<router-outlet></router-outlet>\r\n"